// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"883":"24d09e93","996":"786889f8"}[chunkId] + ".chunk.js";
};